import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
    selector: `app-tollDistributerLayout`,
    templateUrl: `./tollDistributerLayout.component.html`,
    styleUrls: ['./tollDistributerLayout.component.scss']
})

export class TollDistributerLayoutComponent {

    user = this.authService.getTollDistributerUser();

    routes = [
        {
            path: 'srbToll/distributer/clients',
            label: 'Klijenti'
        },
        {
            path: 'tollDistributer/tags',
            label: 'Tagovi'
        },
        {
            path: 'tollDistributer/specifications',
            label: 'Specifikacije'
        },
        {
            path: 'tollDistributer/statistics',
            label: 'Statistika'
        },
        {
            path: 'login',
            label: `Odjavi se`
        }
    ];

    constructor(
        private authService: AuthService
    ) { }
}
